import App from '@app/App';
import { store } from '@app/store';
import theme from '@common/theme';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { isDomainZone } from '@common/utils/lang';
import BitrixChat from '@features/bitrix-chat/BitrixChat';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import GoogleTagManager from './common/components/analytics/GoogleTagManager';
import JivoChat from './common/components/analytics/JivoChat';
import './assets/fonts/f55/f55_font.css';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <GlobalStyles styles={{ body: { userSelect: 'none' } }}/>
          <CssBaseline/>
          <BrowserRouter>
            <GoogleTagManager/>
            {isDomainZone('ru') && <JivoChat/>}
            {isDomainZone('tj') && <BitrixChat/>}
            <App/>
          </BrowserRouter>
        </ThemeProvider>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
